var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.maxLength != 0
        ? _c("el-input", {
            class: { require: _vm.getRequire && _vm.isNull(), item: true },
            attrs: {
              type: "text",
              size: "small",
              placeholder: "请输入内容",
              disabled: _vm.disabled,
              minlength: _vm.minLength,
              maxlength: _vm.maxLength,
              "show-word-limit": "",
            },
            on: { input: _vm.input },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          })
        : _c("el-input", {
            class: { require: _vm.getRequire && _vm.isNull(), item: true },
            attrs: {
              type: "text",
              size: "small",
              placeholder: "请输入内容",
              disabled: _vm.disabled,
              minlength: _vm.minLength,
              "show-word-limit": "",
            },
            on: { input: _vm.input },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          }),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "line-height": "32px" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }